import script from "./FormMultiSelect.vue?vue&type=script&setup=true&lang=js"
export * from "./FormMultiSelect.vue?vue&type=script&setup=true&lang=js"

import "./FormMultiSelect.vue?vue&type=style&index=0&id=7fc45e85&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7fc45e85"]])

export default __exports__